import { Document, Page, Image, pdf, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#fff',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
});

const PdfDocument = ({ base64Image }: { base64Image: string }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <Image src={base64Image} style={styles.image} />
    </Page>
  </Document>
);

export const convertImageToPdf = async (base64Image: string): Promise<string> => {
  const pdfBlob = await pdf(<PdfDocument base64Image={base64Image} />).toBlob();
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.readAsDataURL(pdfBlob);
  });
};
